import { Company, FormatReference } from "../../../../../documaker/domain/format";
import { ObjectTranslator, FormatThumbnailSource } from "../../../../../documaker/infrastructure/format/ver2";
import { IFormatBean } from "../../../../../documaker/infrastructure/format/ver2/beans";
import { EditableFormatPreviewSource } from "../../../../domain/editableFormat/sources";

export class EditableFormatObjectTranslator extends ObjectTranslator {
  public toFormat(getToken: () => string, bean: IFormatBean): FormatReference {
    // 手入力の名前は入れたくない（フォーマット由来の名前を入れたい）が、現状では判定不能
    // バックエンドにツリー編集後の値を返却するときに、手入力された名前かどうかの判定に使用している
    const originalName = bean.name;
    const formatReference = new FormatReference(
      bean.id,
      bean.name,
      new EditableFormatPreviewSource(getToken, bean.id),
      new FormatThumbnailSource(getToken, bean.id),
      bean.reportTypeId,
      bean.masterCode,
      bean.tag,
      new Company(bean.companyCode, bean.companyName),
      bean.categoryType,
      bean.writeMethodType,
      // startDateTime/endDateTimeはMomentで変換してたが、6700個×2プロパティの変換に4秒程度かかってる...使ってないようなので一旦文字列保持に変更.いるかどうかから再考.
      bean.startDateTime ? bean.startDateTime : null,
      bean.endDateTime ? bean.endDateTime : null,
      bean.expired,
      bean.deleted,
      bean.editedName,
      originalName,
    );
    // Vueのリアクティブに登録すると、プロパティがリアクティブなgetter/setterに置換されてメモリを大量に使用してしまうため、
    // 読み取りしかしないオブジェクトについてはObject.freezeすることでリアクティブにさせないようにしている
    Object.freeze(formatReference);
    return formatReference;
  }
}
